export default [
    {
        path: 'loteamento',
        component: () => import(
            /* webpackChunkName: 'cadastro-loteamento' */
            '@/views/cadastro/loteamento/Index'
        ),
        redirect: 'loteamento/index',
        children: [
            {
                name: 'cadastro-loteamento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-loteamento' */
                    '@/views/cadastro/loteamento/List.vue'
                ),
            },
            {
                name: 'cadastro-loteamento-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-loteamento' */
                    '@/views/cadastro/loteamento/Form.vue'
                ),
            },
            {
                name: 'cadastro-loteamento-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-loteamento' */
                    '@/views/cadastro/loteamento/Form.vue'
                ),
            },
        ],
    },
]